import React from 'react';
import { Users, BookCopy, Star, Globe } from 'lucide-react';
export function SocialProofBar() {
  return <div className="bg-brand-accent text-brand-dark py-3 px-4 shadow-[0_0_20px_rgba(200,255,0,0.15)] relative z-20" data-id="element-237">
      <div className="max-w-4xl mx-auto grid grid-cols-4 gap-2 md:gap-6" data-id="element-238">
        <div className="flex flex-col items-center text-center" data-id="element-239">
          <Users className="w-5 h-5 md:w-6 md:h-6 mb-1 text-brand-dark" data-id="element-240" />
          <span className="text-sm md:text-xl font-black leading-none" data-id="element-241">
            +2.000
          </span>
          <span className="text-[8px] md:text-xs font-bold uppercase tracking-wide opacity-80" data-id="element-242">
            entrenadores
          </span>
        </div>
        <div className="flex flex-col items-center text-center" data-id="element-243">
          <BookCopy className="w-5 h-5 md:w-6 md:h-6 mb-1 text-brand-dark" data-id="element-244" />
          <span className="text-sm md:text-xl font-black leading-none" data-id="element-245">
            6 tomos
          </span>
          <span className="text-[8px] md:text-xs font-bold uppercase tracking-wide opacity-80" data-id="element-246">
            listos
          </span>
        </div>
        <div className="flex flex-col items-center text-center" data-id="element-247">
          <div className="flex mb-1" data-id="element-248">
            {[...Array(5)].map((_, i) => <Star key={i} className="w-3 h-3 md:w-5 md:h-5 text-brand-dark fill-current" data-id="element-249" />)}
          </div>
          <span className="text-sm md:text-xl font-black leading-none" data-id="element-250">
            4.9/5
          </span>
          <span className="text-[8px] md:text-xs font-bold uppercase tracking-wide opacity-80" data-id="element-251">
            calificación
          </span>
        </div>
        <div className="flex flex-col items-center text-center" data-id="element-252">
          <Globe className="w-5 h-5 md:w-6 md:h-6 mb-1 text-brand-dark" data-id="element-253" />
          <span className="text-sm md:text-xl font-black leading-none" data-id="element-254">
            LATAM
          </span>
          <span className="text-[8px] md:text-xs font-bold uppercase tracking-wide opacity-80" data-id="element-255">
            hispano
          </span>
        </div>
      </div>
    </div>;
}